import {SET_FOR_ALL_SIDES} from "../constants/action-types";

export const setForAllSides = (forAllSides) => ({
  type: SET_FOR_ALL_SIDES,
  payload: forAllSides
});
